/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import Colors from 'constants/Colors';
import { FontWeight, FiraSansBold } from 'components/Text';
import { Breakpoints } from 'constants/Breakpoints';
import { mediaHelper } from "../../../../utils/src";
import { Field } from 'formik';
import Label from 'components/Form/Label';

export const Content = styled.div`
  background: ${Colors.WHITE};
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  margin-bottom: 50px;
  border: 1px solid ${Colors.BLUE};
  background: ${Colors.WHITE};
  border-radius: 0px 0px 10px 10px;
  box-shadow: 0px 17px 17px 6px ${Colors.GRAY[4]};
  padding: 5px;
  
  ${mediaHelper.sm`
    padding: 10px;
    border-radius: 0px 0px 15px 15px;
  `}
  
  ${mediaHelper.md`
    border-radius: 0px 0px 20px 20px;
  `}
`;

export const Heading = styled.div`
  background: ${Colors.BLUE};
  display:flex;
  align-items:center;
  justify-content: space-between;
  color: ${Colors.WHITE};
  padding: 5px 10px;
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 14px;
  border-radius: 10px 10px 0px 0px;
  margin-top: 20px;
  position: relative;

  ${mediaHelper.sm`
    padding: 10px 15px;
    font-size: 18px;
    border-radius: 15px 15px 0px 0px;
  `}
  
  ${mediaHelper.md`
    border-radius: 20px 20px 0px 0px;
  `}
`;

export const ColIcon = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px;
  padding: 5px;
  justify-content: flex-start;
  align-items: center;
`

export const RowIcon = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FilterContainer = styled.div`
  &.filter-close {
    display: none;
  }

  &.filter-open {
    position: absolute;
    right: 0;
    top: 60px;
    background-color: ${Colors.WHITE};
    z-index: 10;
    padding: 15px;
    width: 450px;
    box-shadow: -5px 5px 20px -10px black;

    > div > div {
      background-color: ${Colors.WHITE};  
    }
  }

  @media (max-width: ${Breakpoints.md}) {
    &.filter-close {
      display: none;
    }

    &.filter-open {
      position: fixed;
      overflow-x: scroll;
      top: 0;
      height: 100%;
      left: 0;
      width: 100%;
      background-color: ${Colors.WHITE};
      z-index: 2000;
      padding: 10px;

      > div > div {
        background-color: ${Colors.WHITE};  
      }
    }
    
    .icon-close {
      position: absolute;
      top: 0;
      right: 0;
      margin: 10px 15px;
      font-size: 30px;
    }
  }
`;

export const FilterSearchContainer = styled.div`
  border-radius: 20px 20px 0 0;
  width: 100%;
  margin-bottom: 10px;
`;

export const MobileLabel = styled.span`
  font-weight: ${FiraSansBold};
  text-transform: uppercase;
  font-size: 16px;
  color: ${Colors.GREEN};
`;

export const RowFilter = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  padding: 5px;
`;

export const CheckBoxColumn = styled.div`
  width: 20%;
`;

export const FilterColumn = styled.div`
  width: 100%;
  position: relative;
`;

export const FieldGrid = styled(Field)`
  border-radius: 4px;
  padding-left: 5px;
  vertical-align: middle;
  
  & div {
    min-height: 0 !important;
    margin-bottom: 0 !important;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px 0px 0px;
`;

export const ButtonContent = styled.div`
  display:flex;
  flex-direction: row;
  background-color:#FFF; 
  justify-content: space-evenly;
  
  @media (max-width: ${Breakpoints.lg}) {  
    flex-wrap: wrap;
    padding-right: 10px;
    width: 100%;
  }
`;

export const TableContainer = styled.div`
width:100%;
`;

export const Scrollbox = styled.div` 
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 1000px;
  padding:10px 20px 10px 10px;
  
  ::-webkit-scrollbar{
    background:${Colors.WHITE};
    width:8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
  `;

export const Text = styled.text`
  color:${props => props.secundary ? Colors.PURPLE : Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  font-size: 16px;
  cursor: pointer;
`;

export const DialogSelect = styled.div`
  width: 100%;  
  margin: 30px 0px 10px 0px;
`;

export const DialogConfirm = styled.button`
  width: calc(50% - 10px);
  margin-left: 10px;
  height: 40px;
  background: ${Colors.BLUE};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
`;

export const NmInsure = styled.text`

    display: flex;
    z-index: 999;

    div{
      display: none;
    }

    :hover{
      div{
        display: flex;
        color:${Colors.PURPLE};
        white-space: nowrap;
        position: absolute;
        background: white;
        width: auto;
        height: auto;
        font-size: 14px;
        font-weight: bold;
      }
    }
`;


export const DialogCancel = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[0]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;
`;

export const DialogRejected = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[6]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;
`;

export const Line = styled.div`
    width: 100%;
    height: 2px;
    background-color: ${Colors.GRAY[4]};
`;

export const DialogIcon = styled.div`
    height: 30px;
    display: inline;
    margin-right: 5px;
    
    ${({ pink }) =>
    pink == "exclamation"
      ? css`
          color: ${Colors.PINK};
          `
      : `display: ${Colors.BLACK};`
  }
    
    font-size: 22px;
    svg{
      float: left;
    }
`;

export const InsurerName = styled.text`
  color:${props => props.secundary ? Colors.PURPLE : Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  font-size: 16px;
  cursor: pointer;
  position: relative;

    :before {
      content: attr(data-hover);
      visibility: hidden;
      opacity: 0;
      width: max-content;
      min-width: 150px;
      background-color: #fff;
      color: black;
      font-weight: ${FontWeight.Regular};
      border-radius: 5px;
      padding: 16px 16px;
      border: 0.5px solid #C0C0C0;
      -webkit-box-shadow: 0px 0px 10px -2px #000000; 
      box-shadow: 0px 0px 10px -2px #000000;
      white-space: pre;
      position: absolute;
      z-index: 1;
      left: 0;
      top: 110%;
    }

    :hover:before {
      opacity: 1;
      visibility: ${props => props[`data-hover`] ? 'visible' : 'hidden'};
    }
`;

export const Table = styled.table`
  border-collapse: collapse;
  padding: 0;
  width: 100%;
`

export const TableHead = styled.thead`
  @media screen and (max-width: 600px) {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
`

export const TableRow = styled.tr`

`;

export const TableHeader = styled.th`
  ${({ minWidth }) => minWidth ? `min-width: ${minWidth}px` : ''}
  ${({ maxWidth }) => maxWidth ? `width: ${maxWidth}px` : ''}
  position: relative;
  vertical-align: top;
  padding: 5px;
  padding-left: 0px;
  ${({ right }) => right ? 'text-align: right !important' : 'text-align: left'}
  span {
    font-size: 12px !important;
  }
`

export const TableBody = styled.tbody`
    tr {
      border-bottom: 2px solid #E0E0E0;
    }
`;

export const TableCollum = styled.td`
  vertical-align: top;
  ${({ right }) => right ? 'text-align: right !important' : 'text-align: left'}
  padding-bottom: 8px;
  padding-top: 8px;
  padding-right: 5px;
  display: table=cell;

  &:last-child {
    padding-right: 0px;
  }

  @media screen and (max-width: ${Breakpoints.sm}) {
    display: flex;
    max-width: unset !important;
    padding-top: 0px;
    padding-bottom: 2px;
    text-align: left;

    &:last-child {
      padding-bottom: 10px;
    }

    &:first-child {
      padding-top: 10px;
    }
  }
`;

export const InlineLabel = styled(Text)`
  display: inline-block;
  width: 30%;
  vertical-align: middle;
  padding-right: 5px;
  justify-content: start;
  align-items: flex-start;
  justify-self: flex-start;
  text-align: left;
  font-size: 12px;
  color: ${Colors.GRAY[3]};
  
  @media screen and (min-width: 600px) {
    display: none;
  }
`;

export const LabelEdit = styled(Label)`
  font-size: 12px;

  @media screen and (max-width: ${Breakpoints.sm}) {
    width: unset;
    text-align: center;
  } 
  
`;

